import PublicSiteLayout from "@/components/layouts/PublicSiteLayout";
import LandingHowItWorks from "@/components/marketing/LandingHowItWorks";
import Seo from "@/components/marketing/Seo";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "How HiredCoach works",
  description:
    "A three-step HiredCoach workflow for loading your background, targeting a role, and practicing interviews and negotiation.",
  step: [
    {
      "@type": "HowToStep",
      position: 1,
      name: "Load in your story",
      text: "Add your resume, experience, and skills so coaching reflects your real background.",
    },
    {
      "@type": "HowToStep",
      position: 2,
      name: "Aim at a real role",
      text: "Add a job target so HiredCoach can tailor prep around the opportunity you want.",
    },
    {
      "@type": "HowToStep",
      position: 3,
      name: "Rehearse the moments that matter",
      text: "Practice interviews, sharpen your pitch, and prepare for offer conversations.",
    },
  ],
};

const HowItWorks = () => {
  return (
    <PublicSiteLayout>
      <Seo
        title="How HiredCoach Works | Resume, Interview, and Salary Negotiation Coaching"
        description="See how HiredCoach helps job seekers load in their story, target real jobs, and prepare for interviews and salary negotiations."
        canonicalPath="/how-it-works"
        keywords="how hiredcoach works, interview prep workflow, resume coaching, job search organization, salary negotiation practice"
        structuredData={structuredData}
      />

      <LandingHowItWorks />

      <section className="bg-white pb-20">
        <div className="container mx-auto px-6 text-center">
          <Button asChild className="rounded-full bg-sky-600 px-8 hover:bg-sky-500">
            <Link to="/register">
              Start With HiredCoach
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </section>
    </PublicSiteLayout>
  );
};

export default HowItWorks;
